import axios from 'axios'
import { useStore } from '~/store'
import { getToken } from '~/utils/auth'
import { notice } from '~/utils/util'
import moment from 'moment'
import qs from 'qs'
import {useGlobSetting} from '~/hooks/setting/index.ts'

console.log(useGlobSetting())
console.log('process.env.VITE_APP_BASE_API', import.meta.env.VITE_APP_BASE_API)
const service = axios.create({
  baseURL: useGlobSetting().VITE_APP_BASE_API,
  timeout: 300 * 1000, // 60s
})
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  const store = useStore()
  const token = getToken()
  if (token) {
    const jwtToken = token.split(".")[1]
    const str = JSON.parse(decodeURIComponent(window.atob(jwtToken)))
    const expTime = moment(str.exp * 1000)
    const nowTime = moment()
    if (expTime < nowTime) {
      // token过期
      notice('登录已过期，请刷新页面并重新登录', 'error')
      store.logout()
      return config
    }
    config.headers["Authorization"] = 'Bearer ' + token
    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        console.log(qs.stringify(params, { arrayFormat: 'repeat' }))
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

service.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  const store = useStore()
  const res = response.data
  if (res != null) {
    if (response.config.responseType === 'blob') {
      // res.type == 'application/octet-stream' || res.type == 'image/jpeg' || res.type == 'image/png'|| res.type == 'image/gif'
      return response
    }
    if (res.code != 20000) {
      notice(res.msg || '请求失败', 'error')
      store.changeLoading(false)
      return Promise.reject(new Error(res.msg || '系统错误'))
    } else {
      return res
    }
  } else {
    if (response.status === 200) {
      return response
    }
    store.changeLoading(false)
    return Promise.reject(new Error(res.msg || '系统错误'))
  }
}, function (error) {
  // 对响应错误做点什么
  const store = useStore()
  console.log('err' + error)
  store.changeLoading(false)
  notice(error.msg || '请求失败', 'error')
  return Promise.reject(error)
})

export default service
